/** PKCE (RFC 7636) helpers for the OAuth public-client flow, built on Web Crypto
 *  (available in all our WebView targets). No Node `crypto`, no external dep. */

function base64url(bytes: Uint8Array): string {
  let bin = "";
  for (const b of bytes) bin += String.fromCharCode(b);
  return btoa(bin).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

function randomBytes(len: number): Uint8Array {
  const out = new Uint8Array(len);
  crypto.getRandomValues(out);
  return out;
}

export interface PkcePair {
  /** High-entropy secret kept on the device; sent on the token exchange. */
  verifier: string;
  /** base64url(SHA-256(verifier)); sent on the authorization request. */
  challenge: string;
}

/** Create a verifier (43–128 char base64url) + its S256 challenge. */
export async function createPkcePair(): Promise<PkcePair> {
  const verifier = base64url(randomBytes(32)); // 32 bytes -> 43 base64url chars
  const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(verifier));
  return { verifier, challenge: base64url(new Uint8Array(digest)) };
}

/** Opaque anti-CSRF state token to echo through the redirect. */
export function randomState(): string {
  return base64url(randomBytes(16));
}
